// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Util from "../../common/util.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as LayoutDataContext from "../../utils/LayoutDataContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactFontawesome from "@fortawesome/react-fontawesome";

function PreviousButton(props) {
  var layoutData = LayoutDataContext.useContext(undefined);
  var registerData = Belt_Option.flatMap(layoutData, (function (o) {
          return o.register;
        }));
  var backButtonText = Belt_Option.mapWithDefault(registerData, "Back", (function (c) {
          return c.backButtonText;
        }));
  return JsxRuntime.jsxs("button", {
              children: [
                JsxRuntime.jsx(ReactFontawesome.FontAwesomeIcon, {
                      icon: [
                        "fas",
                        "arrow-left"
                      ],
                      className: "mr-5 text-2xl text-gray-400 inline-block align-middle"
                    }),
                JsxRuntime.jsx("span", {
                      children: Util.ReactStuff.s(backButtonText),
                      className: "inline-block align-middle text-gray-400"
                    })
              ],
              className: Belt_Option.getWithDefault(props.className, ""),
              id: props.id,
              type: Belt_Option.getWithDefault(props.type_, "button"),
              onClick: props.onClick
            });
}

var make = PreviousButton;

export {
  make ,
}
/* Util Not a pure module */
